// phonics_data_lt15.js
// Letter Teams L15 - L15 Long Vowel Sounds wh, ph
// 路由：/phonics/lt15

const MEDIA_BASE = '/media/phonics/lt15';
const V = 'v1';

export const letterDataLt15 = {
  id: 'lt15',
  letter: 'L15',
  title: 'L15 Long Vowel Sounds wh, ph',
  mediaBase: MEDIA_BASE,

  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "Pink has a phone.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "The phone is white.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Phil is at the sea.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "He is with Ralph.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "They see a whale.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "Let's go to the sea!", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "The pals get in a van.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Pink grabs the wheel.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "They drive past wheat.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "They come to the sea.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "They meet Phil and Ralph.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "I see the whale!", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Splash!", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "The whale makes a big wave.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Oh no! The pals are in the sea.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Help! Help!", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Here come white dolphins.", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "The dolphins save them.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Thank you!", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
      ],
    },
  ],
};
